import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  LeadsSimpleQuery,
  PaginationOptions,
  SearchLeadsRequest,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const LEADS_SIMPLE_QUERY = graphql(`
  query leadsSimple($options: SearchLeadsRequest!, $pagination: PaginationOptions!) {
    leads(SearchLeadRequest: $options, PaginationOptions: $pagination) {
      total
      results {
        id
        name
      }
    }
  }
`);

export function useLeadsSimple(
  request: SearchLeadsRequest,
  pagination: PaginationOptions,
  options?: UseQueryOptions<LeadsSimpleQuery, unknown, LeadsSimpleQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["leadsSimple", request, pagination],
    LEADS_SIMPLE_QUERY,
    [{ options: request, pagination }],
    {
      staleTime: 1000 * 60 * 60, // 1 hour
      ...options,
    },
  );

  return {
    data: data?.leads,
    ...rest,
  };
}
